import type {ConnectElementConfig} from '../../../connect/ConnectJSInterface/ConnectElementList';
import {ComponentOverrideFlag} from '../../../utils/flags/flags';

export const FinancialAccountsConfig: ConnectElementConfig = {
  Component: () =>
    import(
      /* webpackChunkName: "FinancialAccounts" */
      '../../../components/MoneyManagement/FinancialAccounts'
    ),
  releaseState: 'preview',
  enabledOverrideFlag: ComponentOverrideFlag.financial_accounts,
  teamOwner: 'platform-surfaces',
  sentryTeam: 'platform_surfaces_embedded',
  description: 'Displays a list of financial accounts.',
  friendlyName: 'Financial accounts',
  enableV2APIToken: true,
  htmlEvents: ['financialaccountdetailsviewed', 'financialaccountcreated'],
  customHtmlElementMethods: {
    setOnFinancialAccountCreated: {
      type: 'EventListenerMethod',
      event: 'financialaccountcreated',
      isInternal: true,
      description: 'Called after a new financial account is created.',
    },
    setOnAccountDetailsViewed: {
      type: 'EventListenerMethod',
      event: 'financialaccountdetailsviewed',
      isInternal: true,
      description:
        'Called after financial account details successfully display.',
    },
    setTreasuryEntryAction: {
      type: 'SupplementalObject',
      objectToSet: 'treasuryEntryAction',
      isInternal: true,
      description:
        'Opens account details or account creation for a checklist action. Each request needs a unique ID.',
    },
  },
  syntheticTestInfo: {
    testUrl:
      'https://amp.corp.stripe.com/synthetics/us-west-2/efs-financial-accounts-multi-fa',
  },
};
